import PinMapFill from 'assets/icons/pin-map-fill-small.svg';
import { ListedPropertyDetailMemberAuctionProperty, ListedPropertyRoomGetAssessmentDetail } from 'domain/entities/PropertyEntity';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import { StreetView } from 'presentation/components/StreetView';
import { AUTH_ROUTES, PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { COMMON } from 'utilities/constants/COMMON';
import { DATE_FORMAT } from 'utilities/constants/DATE';
import { commonHelpers } from 'utilities/helpers';
import { MapInfo } from '../../../CU-057-01/models/MapInfo';
import { AppProps } from '../../../../../../presentation/App';
import { ButtonGroup } from './ButtonGroup';
import { CURRENT_SITUATION } from 'infrastructure/config/CONSTANTS';
import ImageModal from 'presentation/pages/CU/CU-009-01/components/ImageModal';

interface props {
    listedPropertyId?: number;
    detailAssessment?: ListedPropertyDetailMemberAuctionProperty;
    detailRoomAssessment?: ListedPropertyRoomGetAssessmentDetail
}
export const PropertyDescription = ({ listedPropertyId, detailAssessment, detailRoomAssessment }: props, prop: AppProps) => {
    const navigate = useNavigate();
    const userSlice = useAppSelector((state) => state.user);
    const [isOpen, setIsOpen] = useState(false);
    const [dataNavigate, setDataNavigate] = React.useState<any>();

    useEffect(() => {
        if (detailAssessment) {
            setDataNavigate({
                name: detailAssessment.name,
                rateBuyNow: detailAssessment.rateBuyNow,
                rateHighestAuctionNow: detailAssessment.rateHighestAuctionNow,
                currentHighestAuctionPrice: detailAssessment.currentHighestAuctionPrice,
                askingSalePriceUpperLimit: detailAssessment.askingSalePriceUpperLimit,
                yourAuctionBid: detailAssessment.yourAuctionBid,
                rent: detailAssessment.rent,
                rateYourAuctionBids: detailAssessment.rateYourAuctionBids,
                auctionId: detailAssessment.auctionId,
                currentScheduleSeq: detailAssessment.currentScheduleSeq,
                auctionTime: detailAssessment.auctionTime,
                auctionStatus: detailAssessment.auctionStatus,
            });
        }
    }, [detailAssessment]);

    const openGoogleMap = (lat?: number, lng?: number) => {
        const mapInfo: MapInfo = {
            lat: lat ?? 0,
            lng: lng ?? 0,
            currentPage: window.location.href,
            address: detailAssessment?.residence ?? '',
            propertyName: detailAssessment?.name ?? '',
        };

        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_057_01}`, {
            state: mapInfo,
        });
    };
    const RoomInfo = (props: {
        isBorderBottom?: boolean;
        gap?: number;
        marginRight?: number;
        label: string;
        value: any;
        width?: any;
    }) => {
        return (
            <section
                className={`pd-element ${
                    props.isBorderBottom === undefined || props.isBorderBottom === true
                        ? 'border-bottom-des'
                        : ''
                }`}
                style={{
                    marginRight: props.marginRight ?? 48,
                    width: props.width ?? '100%',
                    minHeight: 50,
                    height: 'fit-content',
                }}
            >
                <div className="label" style={{ marginRight: props.gap ?? 8, minWidth: 100 }}>
                    {props.label}
                </div>
                <div className="value" style={{ flexGrow: 100 }}>
                    {props.value}
                    {detailAssessment?.floorPlanUrl && (
                        <button className="floor-plan-btn" onClick={() => setIsOpen(true)}>
                            間取り図
                        </button>
                        )}
                </div>
            </section>
        );
    };

    const Info = (props: {
        isBorderBottom?: boolean;
        gap?: number;
        marginRight?: number;
        label: string;
        value: any;
        width?: any;
    }) => {
        return (
            <section
                className={`pd-element ${
                    props.isBorderBottom === undefined || props.isBorderBottom === true
                        ? 'border-bottom-des'
                        : ''
                }`}
                style={{
                    marginRight: props.marginRight ?? 48,
                    width: props.width ?? '100%',
                    minHeight: 50,
                    height: 'fit-content',
                }}
            >
                <div className="label" style={{ marginRight: props.gap ?? 8, minWidth: 100 }}>
                    {props.label}
                </div>
                <div className="value" style={{ flexGrow: 100 }}>
                    {props.value}
                </div>
            </section>
        );
    };

    const Address = (props: { data: any }) => {
        return (
            <section
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
            >
                <div style={{wordBreak: 'break-all'}}>{props.data}</div>
                <div
                    className="button-style"
                    onClick={() => openGoogleMap(detailAssessment?.lat, detailAssessment?.lng)}
                >
                    <img alt="" src={PinMapFill} />
                </div>
            </section>
        );
    };

    return (
        <section style={{ marginTop: 32 }}>
            <div style={{ display: 'flex' }} className="border-bottom-des">
                <section style={{ width: 343, marginRight: 26 }}>
                <RoomInfo
                        label="部屋番号"
                        value={
                            detailAssessment?.roomNumber
                                ? `${detailAssessment.roomNumber} 号室`
                                : 'メールアドレス登録後、ご覧いただけます。'
                        }
                        marginRight={0}
                    />
                    <Info
                        label="所在地"
                        value={
                            <Address
                                data={
                                    detailAssessment?.residence
                                        ? `${detailAssessment.residence}`
                                        : COMMON.EMPTY
                                }
                            />
                        }
                        marginRight={0}
                    />
                    <Info
                        isBorderBottom={false}
                        label="交通"
                        value={
                            detailAssessment?.stationName1
                                ? `${detailAssessment?.lineName1 ?? ''} ${detailAssessment.stationName1 ? detailAssessment.stationName1 + '駅' : ''} 徒歩 ${detailAssessment.footMin1} 分`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                </section>
                <section style={{ width: 245, paddingTop: 5 }}>
                    <StreetView
                        containerStyle={{ width: '245px', height: '140px' }}
                        center={{
                            lat: detailAssessment?.lat ?? 0,
                            lng: detailAssessment?.lng ?? 0,
                        }}
                    />
                </section>
            </div>
            <div style={{ display: 'flex' }} className="border-bottom-des">
                <section style={{ width: 320, marginRight: 48 }}>
                    <Info
                        label="専有面積"
                        value={
                            detailAssessment?.occupiedArea
                                ? `${Number(detailAssessment.occupiedArea).toLocaleString('en-US', { maximumFractionDigits: 2 })} m²`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="間取り"
                        value={
                            detailAssessment?.roomLayoutDiv
                                ? `${detailAssessment.roomLayoutDiv}`
                                : COMMON.EMPTY
                        }
                        isBorderBottom={false}
                        marginRight={0}
                    />
                </section>
                <section style={{ width: 320 }}>
                    <Info
                        label="バルコニー面積"
                        value={
                            detailAssessment?.balconyArea
                                ? `${Number(detailAssessment.balconyArea).toLocaleString('en-US', { maximumFractionDigits: 2 })} m²`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                        gap={32}
                    />
                    <Info
                        label="採光面"
                        value={
                            detailAssessment?.glossySurface
                                ? `${detailAssessment.glossySurface}`
                                : COMMON.EMPTY
                        }
                        isBorderBottom={false}
                        marginRight={0}
                        gap={32}
                    />
                </section>
            </div>
            <div style={{ display: 'flex' }} className="border-bottom-des">
                <section
                    style={{
                        width: `${!userSlice?.isSignedIn ? 140 : 320}px`,
                        marginRight: `${!userSlice?.isSignedIn ? 0 : 48}px`,
                    }}
                >
                    <Info
                        label="現況"
                        value={
                            detailRoomAssessment?.result.presentCondDiv
                                ? CURRENT_SITUATION[detailRoomAssessment.result.presentCondDiv as keyof typeof CURRENT_SITUATION] 
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="賃料"
                        value={
                            detailAssessment?.rent
                                ? `${commonHelpers.formatNumberMoney(detailAssessment?.rent)}円/月`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="共益費"
                        value={
                            detailRoomAssessment?.result.managementFee
                                ? `${commonHelpers.formatNumberMoney(detailRoomAssessment?.result.commonServiceFee)}円/月`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="管理費"
                        value={
                            detailRoomAssessment?.result.managementFee
                                ? `${commonHelpers.formatNumberMoney(detailRoomAssessment?.result.managementFee)}円/月`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="修繕積立金"
                        value={
                            detailRoomAssessment?.result.renovationDeposit
                                ? `${Number(detailRoomAssessment?.result.renovationDeposit).toLocaleString('en-US', { maximumFractionDigits: 1 })}円/月`
                                : userSlice?.isSignedIn
                                  ? COMMON.EMPTY
                                  : ''
                        }
                        marginRight={0}
                    />
                    <Info
                        label="その他費用"
                        value={
                            detailAssessment?.otherExpenses01
                                ? `${commonHelpers.formatNumberMoney(detailAssessment?.otherExpenses01)}円/月`
                                : userSlice?.isSignedIn
                                  ? COMMON.EMPTY
                                  : ''
                        }
                        marginRight={0}
                    />
                    <Info
                        label="その他費用備考"
                        value={
                            detailRoomAssessment?.result.otherExpensesNotes
                                ? `${detailRoomAssessment.result.otherExpensesNotes}`
                                : userSlice?.isSignedIn
                                  ? COMMON.EMPTY
                                  : ''
                        }
                        marginRight={0}
                        isBorderBottom={false}
                    />
                </section>
                {!userSlice?.isSignedIn && (
                    <section style={{ width: 550 }}>
                        <div
                            style={{
                                height: 220,
                                background: '#182641',
                                marginTop: 15,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexFlow: 'column',
                                borderRadius: 4,
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 10,
                                    color: '#fff',
                                    opacity: '64%',
                                    height: 20,
                                    marginBottom: 12,
                                }}
                            >
                                ログイン後、ご覧いただけます。
                            </div>
                            <div
                                className="login-form-button"
                                style={{
                                    cursor: 'pointer',
                                    background: '#1F8DDD',
                                    width: 195,
                                    height: 24,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    textAlign: 'center',
                                    fontWeight: 700,
                                    borderRadius: 3,
                                    paddingTop: 2,
                                }}
                                onClick={() =>
                                    !userSlice?.isSignedIn
                                        ? navigate(
                                              `${AUTH_ROUTES.PATH}/${AUTH_ROUTES.SUB.CU_001_00}`,
                                          )
                                        : null
                                }
                            >
                                ログイン・アカウント作成へ
                            </div>
                        </div>
                    </section>
                )}
            </div>
            <div style={{ display: 'flex' }}>
                <section style={{ width: 320, marginRight: 48 }}>
                    <Info
                        label="所在階数"
                        value={
                            // NOTE: 'occupiedFloor'は数値, 'floors'は文字列で「階」を含む
                            detailAssessment?.occupiedFloor && detailAssessment?.floors
                                ? `${detailAssessment.occupiedFloor}階/${detailAssessment?.floors}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="構造"
                        value={
                            detailAssessment?.structureName
                                ? `${detailAssessment.structureName}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="建物管理会社"
                        value={
                            detailAssessment?.realEstateMgmtCompany
                                ? `${detailAssessment.realEstateMgmtCompany}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="施工会社"
                        value={
                            detailAssessment?.constructionCompany
                                ? `${detailAssessment.constructionCompany}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                </section>
                <section style={{ width: 320 }}>
                    <Info
                        label="築年月"
                        value={
                            moment(detailAssessment?.builtAt, true).isValid()
                                ? moment(detailAssessment?.builtAt).format(DATE_FORMAT.FORMAT3)
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                        gap={32}
                    />
                    <Info
                        label="総戸数"
                        value={
                            detailAssessment?.numOfUnit
                                ? `${detailAssessment.numOfUnit}戸`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                        gap={32}
                    />
                    <Info
                        label="分譲会社"
                        value={
                            detailAssessment?.sellingCompany
                                ? `${detailAssessment.sellingCompany}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                        gap={32}
                    />
                    <Info
                        label="管理形態"
                        value={
                            detailAssessment?.managementTypeName !== null &&
                            detailAssessment?.managementTypeName !== undefined
                                ? `${detailAssessment.managementTypeName}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                        gap={32}
                    />
                </section>
            </div>
            <div style={{ width: '100%' }}>
                <Info
                    label="管理員の勤務形態"
                    value={
                        detailAssessment?.workingTypeName !== null &&
                        detailAssessment?.workingTypeName !== undefined
                            ? `${detailAssessment.workingTypeName}`
                            : COMMON.EMPTY
                    }
                    marginRight={0}
                />
            </div>
            <div className="border-bottom-des">
                <ButtonGroup detailAssessment={detailAssessment} />
            </div>
            <div style={{ display: 'flex' }}>
                <section style={{ width: 320, marginRight: 48 }}>
                    <Info
                        label="備考"
                        value={detailAssessment?.notes ? `${detailAssessment.notes}` : COMMON.EMPTY}
                        marginRight={0}
                    />

                    <Info
                        label="取引形態"
                        value={detailAssessment?.transactionType ?? '仲介'}
                        marginRight={0}
                    />
                    <Info
                        label="情報公開日"
                        value={
                            moment(detailAssessment?.termStartDate, true).isValid()
                                ? moment(detailAssessment?.termStartDate).format(DATE_FORMAT.FORMAT4)
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                </section>
                <section style={{ width: 320 }}>
                    <Info
                        label="土地権利"
                        value={
                            detailAssessment?.landUseName
                                ? `${detailAssessment.landUseName}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info label="引渡時期" value={'相談'} marginRight={0} /> {/* hard code */}
                    <Info
                        label="次回更新予定日"
                        value={
                            moment(detailAssessment?.termEndDate, true).isValid()
                                ? moment(detailAssessment?.termEndDate)
                                      .format(DATE_FORMAT.FORMAT4)
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                </section>
            </div>
            <div className="pd-title">取扱店舗</div>
            <section>
                <Info
                    label="広告主の名称"
                    value={
                        detailAssessment?.advertiserName
                            ? `${detailAssessment.advertiserName}`
                            : COMMON.EMPTY
                    }
                    marginRight={0}
                    isBorderBottom={false}
                />
                <Info
                    label="事業所所在地"
                    value={
                        detailAssessment?.officeAddress
                            ? `${detailAssessment.officeAddress}`
                            : COMMON.EMPTY
                    }
                    marginRight={0}
                    isBorderBottom={false}
                />
                <Info
                    label="電話番号"
                    value={
                        detailAssessment?.phoneNumber
                            ? `${detailAssessment.phoneNumber}`
                            : COMMON.EMPTY
                    }
                    marginRight={0}
                    isBorderBottom={false}
                />
                <Info
                    label="宅建免許証番号"
                    value={
                        detailAssessment?.licenseNumber
                            ? `${detailAssessment.licenseNumber}`
                            : COMMON.EMPTY
                    }
                    marginRight={0}
                    isBorderBottom={false}
                />
                <Info
                    label='加盟団体'
                    value={
                        detailAssessment?.storeAffiliatedOrganCode ? `${detailAssessment.storeAffiliatedOrganCode}` : COMMON.EMPTY
                    }
                    marginRight={0}
                    isBorderBottom={false}
                />
            </section>
            {isOpen && (
            <ImageModal
              src={detailAssessment?.floorPlanUrl || ''}
              alt="間取り図"
              onClose={() => setIsOpen(false)}
            />
          )}  
        </section>
    );
};
